export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16 prose prose-slate" data-testid="privacy-page">
      <h1 className="text-3xl font-semibold text-slate-900">Privacy Policy</h1>
      <p className="text-slate-600 mt-4">This privacy policy explains how CarFin India, operated by Red Fort Capital Finance NBFC, collects, uses and protects your personal information.</p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">Information we collect</h2>
      <ul className="text-slate-700 mt-2 list-disc pl-5 space-y-1">
        <li>Identity and contact details (PAN, Aadhaar reference, address, phone, email).</li>
        <li>Employment and income information.</li>
        <li>Vehicle and CarDr diagnostic information.</li>
        <li>Credit bureau and Account Aggregator information (with your consent).</li>
      </ul>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">How we use it</h2>
      <p className="text-slate-700 mt-2">To evaluate creditworthiness, comply with regulatory requirements, originate and service your loan, and improve our products.</p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">Your rights</h2>
      <p className="text-slate-700 mt-2">You may access, correct or withdraw consent for processing of your personal data. Contact our grievance officer at grievance@carfin.com.</p>
    </div>
  );
}
